import { EntityDTO, EntityTypeDTO } from '../../DocumentVault.meta';

export const ENTITY_ICONS = {
  [EntityTypeDTO.File]: 'far fa-file-alt',
  [EntityTypeDTO.Folder]: 'far fa-folder',
  [EntityTypeDTO.Video]: 'fas fa-video',
};

export const SHARED_ENTITY_ICONS = {
  [EntityTypeDTO.File]: 'far fa-file',
  [EntityTypeDTO.Folder]: 'far fa-folder',
  [EntityTypeDTO.Video]: 'far fa-video',
};

export const SHARED_ENTITY_OVERLAY_ICON = 'fas fa-user';

export const getEntityIconClassName = (
  entity: Pick<EntityDTO, 'type' | 'isSharedWithThirdParty'>,
): string => {
  if (entity.isSharedWithThirdParty) {
    return SHARED_ENTITY_ICONS[entity.type];
  }

  return ENTITY_ICONS[entity.type];
};

export const isSharedCompositeEntityIcon = (
  entity: Pick<EntityDTO, 'type' | 'isSharedWithThirdParty' | 'isParentSharedWithThirdParty'>,
): boolean => entity.isSharedWithThirdParty === true && !entity.isParentSharedWithThirdParty;
